export default "__VITE_ASSET__BCezK0Sf__"